import outdatedAndFailed from './outdatedAndFailed';
import outdatedAndPassed from './outdatedAndPassed';
import actualAndFailed from './actualAndFailed';
import actualAndPassed from './actualAndPassed';
import upcomming from './upcomming';

export const enum ATTESTATION_STATUS_ID {
    NOT_FOUND = '9fef2819-aa06-44ff-a4ad-49a50d3f95ae',
    OUTDATED_FAILED = 'c01172b8-f03c-4ec1-b9fb-8b638cb2e8b8',
    OUTDATED_PASSED = '2b3bd0c5-fc52-4d53-a27e-8c440dc06985',
    ACTUAL_FAILED = 'f2805921-2bc1-417d-abe9-837cbecdfd38',
    ACTUAL_PASSED = 'e4e6e178-d7a0-4743-9c88-351cefd94cf5',
    UPCPMMING = '52c90190-70cf-4ebb-851c-9208f8b51536',
};

export const mockList: Record<string, object | null> = {
    [ATTESTATION_STATUS_ID.OUTDATED_FAILED]: outdatedAndFailed,
    [ATTESTATION_STATUS_ID.NOT_FOUND]: null,
    [ATTESTATION_STATUS_ID.OUTDATED_PASSED]: outdatedAndPassed,
    [ATTESTATION_STATUS_ID.ACTUAL_FAILED]: actualAndFailed,
    [ATTESTATION_STATUS_ID.ACTUAL_PASSED]: actualAndPassed,
    [ATTESTATION_STATUS_ID.UPCPMMING]: upcomming,
};